/**
 * Generated file, do not edit directly!
 */

/** Box shadows are used to create the impression of elements being elevated above the background. */

const Surface = {
  /** Surfaces are flat by default and do not have any shadow. */
  Flat: {
    /**
     * Use as the default level of elevation.
     * Css custom property: --dt-box-shadows-surface-flat-rest. Default value: 0px 0px 0px 1px #2d2e4e0d.
     */
    Rest: 'var(--dt-box-shadows-surface-flat-rest, 0px 0px 0px 1px #2d2e4e0d)',
    /**
     * Use as the default level of elevation when a user's pointer is over an interactive surface.
     * Css custom property: --dt-box-shadows-surface-flat-hover. Default value: 0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 4px 8px -2px #2d2e4e12.
     */
    Hover:
      'var(--dt-box-shadows-surface-flat-hover, 0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 4px 8px -2px #2d2e4e12)',
    /**
     * Use as the default level of elevation when the user is pressing an interactive surface.
     * Css custom property: --dt-box-shadows-surface-flat-active. Default value: 0px 0px 0px 1px #2d2e4e0d.
     */
    Active:
      'var(--dt-box-shadows-surface-flat-active, 0px 0px 0px 1px #2d2e4e0d)',
    /**
     * Use as the default level of elevation when moving a surface, on drag-and-drop interaction.
     * Css custom property: --dt-box-shadows-surface-flat-drag. Default value: 0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 7px 17px -2px #2d2e4e52.
     */
    Drag: 'var(--dt-box-shadows-surface-flat-drag, 0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 7px 17px -2px #2d2e4e52)',
  },
  /** Raised surfaces have a subtle shadow, and are used to draw attention to an element. */
  Raised: {
    /**
     * Use for raised surfaces.
     * Css custom property: --dt-box-shadows-surface-raised-rest. Default value: 0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 4px 8px -2px #2d2e4e12.
     */
    Rest: 'var(--dt-box-shadows-surface-raised-rest, 0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 4px 8px -2px #2d2e4e12)',
    /**
     * Use when a user's pointer is over an interactive raised surface.
     * Css custom property: --dt-box-shadows-surface-raised-hover. Default value: 0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 5px 11px -2px #2d2e4e29.
     */
    Hover:
      'var(--dt-box-shadows-surface-raised-hover, 0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 5px 11px -2px #2d2e4e29)',
    /**
     * Use when the user is pressing an interactive raised surface.
     * Css custom property: --dt-box-shadows-surface-raised-active. Default value: 0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 4px 8px -2px #2d2e4e12.
     */
    Active:
      'var(--dt-box-shadows-surface-raised-active, 0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 4px 8px -2px #2d2e4e12)',
    /**
     * Use when moving a raised surface, on drag-and-drop interaction.
     * Css custom property: --dt-box-shadows-surface-raised-drag. Default value: 0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 7px 17px -2px #2d2e4e52.
     */
    Drag: 'var(--dt-box-shadows-surface-raised-drag, 0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 7px 17px -2px #2d2e4e52)',
  },
  /** Floating surfaces have a noticeable shadow, and are used in elements that overlay other content. */
  Floating: {
    /**
     * Use for floating surfaces.
     * Css custom property: --dt-box-shadows-surface-floating-rest. Default value: 0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 5px 11px -2px #2d2e4e29.
     */
    Rest: 'var(--dt-box-shadows-surface-floating-rest, 0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 5px 11px -2px #2d2e4e29)',
    /**
     * Use when a user's pointer is over an interactive floating surface.
     * Css custom property: --dt-box-shadows-surface-floating-hover. Default value: 0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 6px 14px -2px #2d2e4e3d.
     */
    Hover:
      'var(--dt-box-shadows-surface-floating-hover, 0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 6px 14px -2px #2d2e4e3d)',
    /**
     * Use when the user is pressing an interactive floating surface.
     * Css custom property: --dt-box-shadows-surface-floating-active. Default value: 0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 5px 11px -2px #2d2e4e29.
     */
    Active:
      'var(--dt-box-shadows-surface-floating-active, 0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 5px 11px -2px #2d2e4e29)',
    /**
     * Use when moving a floating surface, on drag-and-drop interaction.
     * Css custom property: --dt-box-shadows-surface-floating-drag. Default value: 0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 7px 17px -2px #2d2e4e52.
     */
    Drag: 'var(--dt-box-shadows-surface-floating-drag, 0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 7px 17px -2px #2d2e4e52)',
  },
};
const Field = {
  Neutral: {
    Emphasized: {
      /**
       * Use for emphasized neutral button and input in rest state.
       * Css custom property: --dt-box-shadows-field-neutral-emphasized-rest. Default value: inset 0px 0px 0px 1px #2f2f4f1f, inset 0px -1px 0px #2f2f4f14, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #fff.
       */
      Rest: 'var(--dt-box-shadows-field-neutral-emphasized-rest, inset 0px 0px 0px 1px #2f2f4f1f, inset 0px -1px 0px #2f2f4f14, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #fff)',
      /**
       * Use for emphasized neutral button and input in hover state.
       * Css custom property: --dt-box-shadows-field-neutral-emphasized-hover. Default value: inset 0px 0px 0px 1px #2f2f4f1f, inset 0px -1px 0px #2f2f4f14, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #dadbe4.
       */
      Hover:
        'var(--dt-box-shadows-field-neutral-emphasized-hover, inset 0px 0px 0px 1px #2f2f4f1f, inset 0px -1px 0px #2f2f4f14, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #dadbe4)',
      /**
       * Use for emphasized neutral button and input in active state.
       * Css custom property: --dt-box-shadows-field-neutral-emphasized-active. Default value: inset 0px 0px 0px 1px #2f2f4f1f, inset 0px -1px 0px #2f2f4f14, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #d0d1dc.
       */
      Active:
        'var(--dt-box-shadows-field-neutral-emphasized-active, inset 0px 0px 0px 1px #2f2f4f1f, inset 0px -1px 0px #2f2f4f14, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #d0d1dc)',
    },
    /**
     * Use for accentuated neutral button.
     * Css custom property: --dt-box-shadows-field-neutral-accent. Default value: inset 0px 0px 0px 1px #0000004d, inset 0px -1px 0px #0000008c, 0px 1px 1px -1px #2d2e4e1f.
     */
    Accent:
      'var(--dt-box-shadows-field-neutral-accent, inset 0px 0px 0px 1px #0000004d, inset 0px -1px 0px #0000008c, 0px 1px 1px -1px #2d2e4e1f)',
    /**
     * Use for disabled neutral button and input.
     * Css custom property: --dt-box-shadows-field-neutral-disabled. Default value: inset 0px 0px 0px 1px #2f2f4f0f, inset 0px -1px 0px #2f2f4f0a, 0px 1px 1px -1px #2d2e4e1f.
     */
    Disabled:
      'var(--dt-box-shadows-field-neutral-disabled, inset 0px 0px 0px 1px #2f2f4f0f, inset 0px -1px 0px #2f2f4f0a, 0px 1px 1px -1px #2d2e4e1f)',
  },
  Primary: {
    Emphasized: {
      /**
       * Use for emphasized primary button in rest state.
       * Css custom property: --dt-box-shadows-field-primary-emphasized-rest. Default value: inset 0px 0px 0px 1px #250f980f, inset 0px -1px 0px #250f981a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #e1e5f7.
       */
      Rest: 'var(--dt-box-shadows-field-primary-emphasized-rest, inset 0px 0px 0px 1px #250f980f, inset 0px -1px 0px #250f981a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #e1e5f7)',
      /**
       * Use for emphasized primary button in hover state.
       * Css custom property: --dt-box-shadows-field-primary-emphasized-hover. Default value: inset 0px 0px 0px 1px #250f980f, inset 0px -1px 0px #250f981a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #d5dbf6.
       */
      Hover:
        'var(--dt-box-shadows-field-primary-emphasized-hover, inset 0px 0px 0px 1px #250f980f, inset 0px -1px 0px #250f981a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #d5dbf6)',
      /**
       * Use for emphasized primary button in active state.
       * Css custom property: --dt-box-shadows-field-primary-emphasized-active. Default value: inset 0px 0px 0px 1px #250f980f, inset 0px -1px 0px #250f981a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #c9d1f4.
       */
      Active:
        'var(--dt-box-shadows-field-primary-emphasized-active, inset 0px 0px 0px 1px #250f980f, inset 0px -1px 0px #250f981a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #c9d1f4)',
    },
    /**
     * Use for accentuated primary button.
     * Css custom property: --dt-box-shadows-field-primary-accent. Default value: inset 0px 0px 0px 1px #250f9833, inset 0px -1px 0px #250f984d, 0px 1px 1px -1px #2d2e4e1f.
     */
    Accent:
      'var(--dt-box-shadows-field-primary-accent, inset 0px 0px 0px 1px #250f9833, inset 0px -1px 0px #250f984d, 0px 1px 1px -1px #2d2e4e1f)',
    /**
     * Use for disabled primary button.
     * Css custom property: --dt-box-shadows-field-primary-disabled. Default value: inset 0px 0px 0px 1px #2f2f4f0f, inset 0px -1px 0px #2f2f4f0a, 0px 1px 1px -1px #2d2e4e1f.
     */
    Disabled:
      'var(--dt-box-shadows-field-primary-disabled, inset 0px 0px 0px 1px #2f2f4f0f, inset 0px -1px 0px #2f2f4f0a, 0px 1px 1px -1px #2d2e4e1f)',
  },
  Success: {
    Emphasized: {
      /**
       * Use for emphasized success button in rest state.
       * Css custom property: --dt-box-shadows-field-success-emphasized-rest. Default value: inset 0px 0px 0px 1px #003b360f, inset 0px -1px 0px #003b361a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #e0e7e6.
       */
      Rest: 'var(--dt-box-shadows-field-success-emphasized-rest, inset 0px 0px 0px 1px #003b360f, inset 0px -1px 0px #003b361a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #e0e7e6)',
      /**
       * Use for emphasized success button in hover state.
       * Css custom property: --dt-box-shadows-field-success-emphasized-hover. Default value: inset 0px 0px 0px 1px #003b360f, inset 0px -1px 0px #003b361a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #d3dedd.
       */
      Hover:
        'var(--dt-box-shadows-field-success-emphasized-hover, inset 0px 0px 0px 1px #003b360f, inset 0px -1px 0px #003b361a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #d3dedd)',
      /**
       * Use for emphasized success button in active state.
       * Css custom property: --dt-box-shadows-field-success-emphasized-active. Default value: inset 0px 0px 0px 1px #003b360f, inset 0px -1px 0px #003b361a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #c7d5d3.
       */
      Active:
        'var(--dt-box-shadows-field-success-emphasized-active, inset 0px 0px 0px 1px #003b360f, inset 0px -1px 0px #003b361a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #c7d5d3)',
    },
    /**
     * Use for accentuated success button.
     * Css custom property: --dt-box-shadows-field-success-accent. Default value: inset 0px 0px 0px 1px #003b3626, inset 0px -1px 0px #003b364d, 0px 1px 1px -1px #2d2e4e1f.
     */
    Accent:
      'var(--dt-box-shadows-field-success-accent, inset 0px 0px 0px 1px #003b3626, inset 0px -1px 0px #003b364d, 0px 1px 1px -1px #2d2e4e1f)',
    /**
     * Use for disabled success button.
     * Css custom property: --dt-box-shadows-field-success-disabled. Default value: inset 0px 0px 0px 1px #2f2f4f0f, inset 0px -1px 0px #2f2f4f0a, 0px 1px 1px -1px #2d2e4e1f.
     */
    Disabled:
      'var(--dt-box-shadows-field-success-disabled, inset 0px 0px 0px 1px #2f2f4f0f, inset 0px -1px 0px #2f2f4f0a, 0px 1px 1px -1px #2d2e4e1f)',
  },
  Warning: {
    Emphasized: {
      /**
       * Use for emphasized warning button in rest state.
       * Css custom property: --dt-box-shadows-field-warning-emphasized-rest. Default value: inset 0px 0px 0px 1px #512a000f, inset 0px -1px 0px #512a001a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f9f0e5.
       */
      Rest: 'var(--dt-box-shadows-field-warning-emphasized-rest, inset 0px 0px 0px 1px #512a000f, inset 0px -1px 0px #512a001a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f9f0e5)',
      /**
       * Use for emphasized warning button in hover state.
       * Css custom property: --dt-box-shadows-field-warning-emphasized-hover. Default value: inset 0px 0px 0px 1px #512a000f, inset 0px -1px 0px #512a001a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f9ebdb.
       */
      Hover:
        'var(--dt-box-shadows-field-warning-emphasized-hover, inset 0px 0px 0px 1px #512a000f, inset 0px -1px 0px #512a001a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f9ebdb)',
      /**
       * Use for emphasized warning button in active state.
       * Css custom property: --dt-box-shadows-field-warning-emphasized-active. Default value: inset 0px 0px 0px 1px #512a000f, inset 0px -1px 0px #512a001a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f9e6d0.
       */
      Active:
        'var(--dt-box-shadows-field-warning-emphasized-active, inset 0px 0px 0px 1px #512a000f, inset 0px -1px 0px #512a001a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f9e6d0)',
    },
    /**
     * Use for accentuated warning button.
     * Css custom property: --dt-box-shadows-field-warning-accent. Default value: inset 0px 0px 0px 1px #512a001a, inset 0px -1px 0px #512a0033, 0px 1px 1px -1px #2d2e4e1f.
     */
    Accent:
      'var(--dt-box-shadows-field-warning-accent, inset 0px 0px 0px 1px #512a001a, inset 0px -1px 0px #512a0033, 0px 1px 1px -1px #2d2e4e1f)',
    /**
     * Use for disabled warning button.
     * Css custom property: --dt-box-shadows-field-warning-disabled. Default value: inset 0px 0px 0px 1px #2f2f4f0f, inset 0px -1px 0px #2f2f4f0a, 0px 1px 1px -1px #2d2e4e1f.
     */
    Disabled:
      'var(--dt-box-shadows-field-warning-disabled, inset 0px 0px 0px 1px #2f2f4f0f, inset 0px -1px 0px #2f2f4f0a, 0px 1px 1px -1px #2d2e4e1f)',
  },
  Critical: {
    Emphasized: {
      /**
       * Use for emphasized critical button and input in rest state.
       * Css custom property: --dt-box-shadows-field-critical-emphasized-rest. Default value: inset 0px 0px 0px 1px #7500130f, inset 0px -1px 0px #7500131a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f8e1e1.
       */
      Rest: 'var(--dt-box-shadows-field-critical-emphasized-rest, inset 0px 0px 0px 1px #7500130f, inset 0px -1px 0px #7500131a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f8e1e1)',
      /**
       * Use for emphasized critical button and input in hover state.
       * Css custom property: --dt-box-shadows-field-critical-emphasized-hover. Default value: inset 0px 0px 0px 1px #7500130f, inset 0px -1px 0px #7500131a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f6d6d5.
       */
      Hover:
        'var(--dt-box-shadows-field-critical-emphasized-hover, inset 0px 0px 0px 1px #7500130f, inset 0px -1px 0px #7500131a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f6d6d5)',
      /**
       * Use for emphasized critical button and input in active state.
       * Css custom property: --dt-box-shadows-field-critical-emphasized-active. Default value: inset 0px 0px 0px 1px #7500130f, inset 0px -1px 0px #7500131a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f5cac9.
       */
      Active:
        'var(--dt-box-shadows-field-critical-emphasized-active, inset 0px 0px 0px 1px #7500130f, inset 0px -1px 0px #7500131a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f5cac9)',
    },
    /**
     * Use for accentuated critical button.
     * Css custom property: --dt-box-shadows-field-critical-accent. Default value: inset 0px 0px 0px 1px #75001333, inset 0px -1px 0px #7500134d, 0px 1px 1px -1px #2d2e4e1f.
     */
    Accent:
      'var(--dt-box-shadows-field-critical-accent, inset 0px 0px 0px 1px #75001333, inset 0px -1px 0px #7500134d, 0px 1px 1px -1px #2d2e4e1f)',
    /**
     * Use for disabled critical button and input.
     * Css custom property: --dt-box-shadows-field-critical-disabled. Default value: inset 0px 0px 0px 1px #2f2f4f0f, inset 0px -1px 0px #2f2f4f0a, 0px 1px 1px -1px #2d2e4e1f.
     */
    Disabled:
      'var(--dt-box-shadows-field-critical-disabled, inset 0px 0px 0px 1px #2f2f4f0f, inset 0px -1px 0px #2f2f4f0a, 0px 1px 1px -1px #2d2e4e1f)',
  },
};
export default {
  Surface,
  Field,
};
